import { map, mergeMap, catchError } from "rxjs/operators";
import { ofType } from "redux-observable";
import { sendEmailsService } from "../../../common/services";
import * as actionTypes from "./actionTypes";
import * as sendEmailsActions from "./actions";
import { of } from "rxjs";

export function sendEmails(action$) {
  return action$.pipe(
    ofType(actionTypes.SEND_EMAILS),
    mergeMap(({ payload }) => {
      return sendEmailsService.sendEmails(payload).pipe(
        map((res) =>
          sendEmailsActions.sendEmailsSuccess(res.responceObject.records)
        ),
        // retryWhen(error$ => error$.pipe(
        //   delay(1000),
        //   map((val) => {
        //     payload.retry -= 1;
        //     if (payload.retry === 0) {
        //       throw new Error(val)
        //     }
        //   })
        // )),
        catchError((error) =>
          of({
            type: actionTypes.SEND_EMAILS_FAILED,
            payload: error,
            error: true,
          })
        )
      );
    })
  );
}

export function saveEmailText(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_EMAIL_TEXT),
    mergeMap(({ payload }) => {
      return sendEmailsService.saveEmailText(payload).pipe(
        map((res) =>
          sendEmailsActions.saveEmailTextSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}

export function updateEmailText(action$) {
  console.log("passed");
  return action$.pipe(
    ofType(actionTypes.UPDATE_EMAIL_TEXT),
    mergeMap(({ payload }) => {
      return sendEmailsService.updateEmailText(payload).pipe(
        map((res) =>
          sendEmailsActions.updateEmailTextSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}

export function getEmailText(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_WEEKLY_EMAIL_TEXT),
    mergeMap(({ payload }) => {
      console.log(payload);
      return sendEmailsService.getEmailText(payload).pipe(
        map((res) =>
          sendEmailsActions.getEmailTextSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
export function sendWeeklyEmails(action$) {
  return action$.pipe(
    ofType(actionTypes.SEND_WEEKLY_EMAILS),
    mergeMap(({ payload }) => {
      return sendEmailsService.sendEmails(payload).pipe(
        map((res) =>
          sendEmailsActions.sendWeeklyEmailsSuccess(res.responceObject.records)
        ),
        // retryWhen(error$ => error$.pipe(
        //   delay(1000),
        //   map((val) => {
        //     payload.retry -= 1;
        //     if (payload.retry === 0) {
        //       throw new Error(val)
        //     }
        //   })
        // )),
        catchError((error) =>
          of({
            type: actionTypes.SEND_WEEKLY_EMAILS_FAILED,
            payload: error,
            error: true,
          })
        )
      );
    })
  );
}
